import styled, { css } from "styled-components";

const Wrapper = styled.div(({ theme }) => css`
  .modalContent {
    padding: 16px;
  }

  .modalContent h3 {
    margin-top: ${theme.fonts.sizes.p3};
    margin-bottom: ${theme.fonts.sizes.p3};
  }

  .label-text {
    font-size: 13px;
    color: ${theme.palette.grayscale.darkGray};
    line-height: 16px;
    margin-bottom: 0;
  }

  a {
    color: ${theme.buttons.link.color};
    text-decoration: none;
  }

  ul {
    padding-left: 30px;
    list-style: initial;
  }

  ul li {
    font-size: 13px;
    color: ${theme.palette.grayscale.darkGray};
    line-height: 16px;
    margin-bottom: 12px;
  }
`);

export default Wrapper;
